module.exports = __webpack_public_path__ + "static/media/search.e9485a37.png";